import { enablePointerEvents } from '@utils/pointer-events-control';
import { config, gameState, dartTarget } from '@js/state';

var correctAnswer = false; //to check whether one attempt is correct or not
var attempts = 0; //to check attempts for each question
var mul = 1; //to change the position of the correct bulb for every correct answer

var hintOn = false;
var goDown = true; //boolean for all shapes to go down

var goDownHangerLines; //boolean for all hanger lines to go down

var goUpShape1 = false;
var goUpShape2 = false;
var goUpShape3 = false;
var goUpShape4 = false;
//boolean for each shape to go up

var goUpAllShapes = false; //boolean for all shapes to go up at once

var volumes = [0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.1, 0.0];
var volumeState = 0;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: "GameScene",
    });
  }

  preload() {
    //data pulled from start scene
    // this.load.audio("bgaudio", "assets/Audio/BG music.mp3");
    // this.load.audio("confettiAudio", "assets/Audio/confetti.wav");
    // this.load.audio("correctAudio", "assets/Audio/correct answer.wav");
    // this.load.audio("dartHitAudio", "assets/Audio/Dart throw.wav");
    // this.load.audio("onShapeAudio", "assets/Audio/dart hover.wav");
    // this.load.audio("greenLitAudio", "assets/Audio/Green light.mp3");
    // this.load.audio("hintAudio", "assets/Audio/Hints.mp3");
    // this.load.audio("wrongAudio", "assets/Audio/Wrong answer.mp3");
    // this.load.audio("yayAudio", "assets/Audio/Yay.wav");
    // for (let i = 1; i <= 3; i++) {
    //   this.load.audio("ta" + i, "assets/Audio/ta" + i + ".mp3");
    // }
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    
    goDown = true; mul=1;correctAnswer=false;attempts=0;hintOn=false;
    //@ts-check

    var dartHitAudio = this.sound.add("dartHitAudio").setVolume(0.1);
    var greenLitAudio = this.sound.add("greenLitAudio").setVolume(0.1);
    var correctAudio = this.sound.add("correctAudio").setVolume(0.1);
    var onShapeAudio = this.sound.add("onShapeAudio").setVolume(0.1);
    var confettiAudio = this.sound.add("confettiAudio").setVolume(0.05);
    var hintAudio = this.sound.add("hintAudio").setVolume(0.1);
    var wrongAudio = this.sound.add("wrongAudio").setVolume(0.1);
    var yayAudio = this.sound.add("yayAudio").setVolume(0.1);
    //Harsh

    this.time.delayedCall(
      200,
      function () {
        goDownHangerLines = true;
      },
      [],
      this
    );

    gameState.questionNumber = 1;
    this.add.sprite(config.width / 2, config.height / 2, "scene2BG").setScale(0.25);
    this.parachute = this.add.sprite(1180, 320, "parachute").setScale(0.8);

    this.cloudRight = this.add.sprite(1000, 280, "cloudRight").setScale(1);

    this.cartWheel = this.add.sprite(250, 400, "cartWheel").setScale(0.7).setAlpha(0.4);
    this.add.sprite(config.width / 2, config.height / 2 + 85, "shop");

    this.hangerLine1 = this.physics.add.sprite(341.5, 150, "hangerLine");
    this.hangerLine2 = this.physics.add.sprite(541.5, 150, "hangerLine");
    this.hangerLine3 = this.physics.add.sprite(741.5, 150, "hangerLine");
    this.hangerLine4 = this.physics.add.sprite(941.5, 150, "hangerLine");

    this.fractionBoard = this.add.sprite(config.width / 2, config.height / 2 + 242, "fractionBoard");
    this.fraction = this.add.sprite(config.width / 2, config.height / 2 + 242, "fraction_1");

    this.shopTop = this.add.sprite(config.width / 2, config.height / 2 - 205, "shopTop").setDepth(3);
    this.add.sprite(384, 106, "correctBulb").setDepth(4);

    this.maskImage = this.add.image(config.width / 2, config.height / 2 - 20, "mask").setVisible(false);
    this.mask = this.maskImage.createBitmapMask();

    this.flagWave = this.add.sprite(config.width / 2 + 20, 278, "flagWave").setScale(0.8);
    this.anims.create({
      key: "wave",
      frames: this.anims.generateFrameNames("flagWave", {
        start: 0,
        end: 121,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: -1,
    });

    this.flagWave.play("wave");

    this.shape1 = this.physics.add.sprite(341.5, 150, "question_1_1");
    this.shape2 = this.physics.add.sprite(541.5, 150, "question_1_2");
    this.shape3 = this.physics.add.sprite(741.5, 150, "question_1_3");
    this.shape4 = this.physics.add.sprite(941.5, 150, "question_1_4");

    this.shape1.setDisplaySize(120, 120);
    this.shape2.setDisplaySize(120, 120);
    this.shape3.setDisplaySize(120, 120);
    this.shape4.setDisplaySize(120, 120);

    this.shape1.setMask(this.mask);
    this.shape2.setMask(this.mask);
    this.shape3.setMask(this.mask);
    this.shape4.setMask(this.mask);

    this.hangerLine1.setMask(this.mask);
    this.hangerLine2.setMask(this.mask);
    this.hangerLine3.setMask(this.mask);
    this.hangerLine4.setMask(this.mask);

    this.shape1.setInteractive();
    this.shape2.setInteractive();
    this.shape3.setInteractive();
    this.shape4.setInteractive();

    this.shapeOverEvent(this.shape1, onShapeAudio);
    this.shapeOutEvent(this.shape1);
    this.shapeOverEvent(this.shape2, onShapeAudio);
    this.shapeOutEvent(this.shape2);
    this.shapeOverEvent(this.shape3, onShapeAudio);
    this.shapeOutEvent(this.shape3);
    this.shapeOverEvent(this.shape4, onShapeAudio);
    this.shapeOutEvent(this.shape4);

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.hint = this.add.sprite(240, 575, "hint_1").setScale(0.8).setVisible(false).setDepth(6);
    this.closeHintButton = this.add.sprite(435, 485, "closeHint").setVisible(false).setDepth(6).setInteractive({ cursor: "pointer" });

    this.hintButton = this.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(6).setInteractive({ cursor: "pointer", pixelPerferct: true });
    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.hintButton.on(
      "pointerup",
      function (pointer) {
        gameState.hints += 1;

        this.hintButton.play("idle");

        if (attempts == 1) {
          this.hint.setTexture("hint_1");
          this.shape1.removeInteractive();
          this.shape2.removeInteractive();
          this.shape3.removeInteractive();
          this.shape4.removeInteractive();
          this.overlay.setVisible(true).setDepth(5);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.shape1.removeInteractive();
          this.shape2.removeInteractive();
          this.shape3.removeInteractive();
          this.shape4.removeInteractive();

          this.overlay.setVisible(true).setDepth(5);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.hintButton.disableInteractive();
        this.shape1.setInteractive();
        this.shape2.setInteractive();
        this.shape3.setInteractive();
        this.shape4.setInteractive();
        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);

        this.hintButton.play("pop_out");

        hintOn = false;
      },
      this
    );

    this.dartHitAnim_1 = this.physics.add.sprite(config.width / 2, config.height / 2, "dartHit_1");
    this.anims.create({
      key: "hit_1",
      frames: this.anims.generateFrameNames("dartHit_1", {
        start: 0,
        end: 60,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.dartHitAnim_2 = this.physics.add.sprite(config.width / 2, config.height / 2, "dartHit_2");
    this.anims.create({
      key: "hit_2",
      frames: this.anims.generateFrameNames("dartHit_2", {
        start: 0,
        end: 60,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.dartHitAnim_3 = this.physics.add.sprite(config.width / 2, config.height / 2, "dartHit_3");
    this.anims.create({
      key: "hit_3",
      frames: this.anims.generateFrameNames("dartHit_3", {
        start: 0,
        end: 60,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.dartHitAnim_4 = this.physics.add.sprite(config.width / 2, config.height / 2, "dartHit_4");
    this.anims.create({
      key: "hit_4",
      frames: this.anims.generateFrameNames("dartHit_4", {
        start: 0,
        end: 60,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    //incorrect hit animations

    this.dartMissAnim_1 = this.add.sprite(config.width / 2, config.height / 2, "dartMiss_1");
    this.anims.create({
      key: "miss_1",
      frames: this.anims.generateFrameNames("dartMiss_1", {
        start: 0,
        end: 45,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.dartMissAnim_2 = this.add.sprite(config.width / 2, config.height / 2, "dartMiss_2");
    this.anims.create({
      key: "miss_2",
      frames: this.anims.generateFrameNames("dartMiss_2", {
        start: 0,
        end: 45,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.dartMissAnim_3 = this.add.sprite(config.width / 2, config.height / 2, "dartMiss_3");
    this.anims.create({
      key: "miss_3",
      frames: this.anims.generateFrameNames("dartMiss_3", {
        start: 0,
        end: 45,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.dartMissAnim_4 = this.add.sprite(config.width / 2, config.height / 2, "dartMiss_4");
    this.anims.create({
      key: "miss_4",
      frames: this.anims.generateFrameNames("dartMiss_4", {
        start: 0,
        end: 45,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.correctAnswer = this.add.sprite(341.5, 350, "confetti").setScale(0.5);
    this.anims.create({
      key: "celebrate",
      frames: this.anims.generateFrameNames("confetti", {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.shape1.on(
      "pointerup",
      function (pointer) {
        if (gameState.questionNumber == 3 || gameState.questionNumber == 6 || gameState.questionNumber == 10) {
          dartHitAudio.play();
          this.shape1.setDisplaySize(120, 120);
          this.correctAttempt(this.dartHitAnim_1, "hit_1", this.shape1, 341.5, 350, correctAudio, confettiAudio, greenLitAudio, yayAudio);
        } else {
          this.shape1.setDisplaySize(120, 120);
          this.incorrectAttempt(this.dartMissAnim_1, "miss_1", this.shape1, wrongAudio, hintAudio);
        }
      },
      this
    ); //button 1 end

    this.shape2.on(
      "pointerup",
      function (pointer) {
        if (gameState.questionNumber == 7 || gameState.questionNumber == 2 || gameState.questionNumber == 8) {
          dartHitAudio.play();
          this.shape2.setDisplaySize(120, 120);
          this.correctAttempt(this.dartHitAnim_2, "hit_2", this.shape2, 541.5, 350, correctAudio, confettiAudio, greenLitAudio, yayAudio);
        } else {
          this.shape2.setDisplaySize(120, 120);
          this.incorrectAttempt(this.dartMissAnim_2, "miss_2", this.shape2, wrongAudio, hintAudio);
        }
      },
      this
    );

    this.shape3.on(
      "pointerup",
      function (pointer) {
        if (gameState.questionNumber == 1 || gameState.questionNumber == 4 || gameState.questionNumber == 9) {
          this.shape3.setDisplaySize(120, 120);
          dartHitAudio.play();
          this.correctAttempt(this.dartHitAnim_3, "hit_3", this.shape3, 741.5, 350, correctAudio, confettiAudio, greenLitAudio, yayAudio);
        } else {
          this.shape3.setDisplaySize(120, 120);
          this.incorrectAttempt(this.dartMissAnim_3, "miss_3", this.shape3, wrongAudio, hintAudio);
        }
      },
      this
    );

    this.shape4.on(
      "pointerup",
      function (pointer) {
        if (gameState.questionNumber == 5) {
          this.shape4.setDisplaySize(120, 120);
          dartHitAudio.play();
          this.correctAttempt(this.dartHitAnim_4, "hit_4", this.shape4, 941.5, 350, correctAudio, confettiAudio, greenLitAudio, yayAudio);
        } else {
          this.shape4.setDisplaySize(120, 120);
          this.incorrectAttempt(this.dartMissAnim_4, "miss_4", this.shape4, wrongAudio, hintAudio);
        }
      },
      this
    );
  }

  shapeOverEvent(buttonName, audio) {
    buttonName.on("pointerover", function (pointer) {
      buttonName.setDisplaySize(138, 138);
      audio.play();
    });
  }

  shapeOutEvent(buttonName) {
    buttonName.on("pointerout", function (pointer) {
      buttonName.setDisplaySize(120, 120);
    });
  }

  incorrectAttempt(animObject, animKey, object, missaudio, hintaudio) {
    this.hintButton.setInteractive({ cursor: "pointer" });
    correctAnswer = false;
    attempts += 1;
    //console.log(attempts);
    animObject.play(animKey).setDepth(3);

    this.shape1.removeInteractive();
    this.shape2.removeInteractive();
    this.shape3.removeInteractive();
    this.shape4.removeInteractive();

    this.time.delayedCall(
      1000,
      function () {
        object.setTint(0xda5107); //background: #DA5107;
        missaudio.play();
        if (attempts == 1 || attempts == 2) {
          hintOn = true;
          this.hintButton.play("pop");
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1500,
      function () {
        if (hintOn) {
          this.hintButton.play("breathe");
          //hintaudio.play();
        }

        //animObject.setMask(this.mask);
        object.setTint();
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        this.shape1.setInteractive();
        this.shape2.setInteractive();
        this.shape3.setInteractive();
        this.shape4.setInteractive();
      },
      [],
      this
    );

    if (attempts == 3) {
      if (hintOn == true) {
        this.hintButton.play("pop_out");
        //hintaudio.play();
        hintOn = false;
      }

      goDown = false;
      goDownHangerLines = false;
      gameState.questionNumber += 1;
      gameState.attempted += 1;

      this.time.delayedCall(
        1500,
        function () {
          goUpAllShapes = true;
        },
        [],
        this
      );

      this.time.delayedCall(
        3000,
        function () {
          if (gameState.attempted == 10) {
            gameState.gameWin = false;
            this.scene.stop("TutorialScene");
            this.scene.start("EndScene");
          }
          this.changeQuestion();
          goUpAllShapes = false;
        },
        [],
        this
      );

      this.time.delayedCall(
        3300,
        function () {
          goDownHangerLines = true;
          attempts = 0;
        },
        [],
        this
      );
    }
    //add end screen check all line length
  }

  changeShapes(option1, option2, option3, option4, fraction) {
    this.fraction.setTexture(fraction);

    // this.hintButton.stop('hint');
    //this.hintButton.setFrame('seq_0_0.png');

    this.shape1.setTexture(option1);
    this.shape2.setTexture(option2);
    this.shape3.setTexture(option3);
    this.shape4.setTexture(option4);

    // Source textures vary in dimensions across waves (e.g. Q3 has 96-tall shapes,
    // Q4 has 124x108). Re-pin display size so every wave renders uniformly.
    this.shape1.setDisplaySize(120, 120);
    this.shape2.setDisplaySize(120, 120);
    this.shape3.setDisplaySize(120, 120);
    this.shape4.setDisplaySize(120, 120);

    this.shape1.setInteractive();
    this.shape2.setInteractive();
    this.shape3.setInteractive();
    this.shape4.setInteractive();

    goDown = true;
  }

  changeQuestion() {
    if (gameState.questionNumber == 2) {
      this.changeShapes("question_2_1", "question_2_2", "question_2_3", "question_2_4", "fraction_2");
    } else if (gameState.questionNumber == 3) {
      this.changeShapes("question_3_1", "question_3_2", "question_3_3", "question_3_4", "fraction_3");
    } else if (gameState.questionNumber == 4) {
      this.changeShapes("question_4_1", "question_4_2", "question_4_3", "question_4_4", "fraction_4");
    } else if (gameState.questionNumber == 5) {
      this.changeShapes("question_5_1", "question_5_2", "question_5_3", "question_5_4", "fraction_5");
    } else if (gameState.questionNumber == 6) {
      this.changeShapes("question_6_1", "question_6_2", "question_6_3", "question_6_4", "fraction_6");
    } else if (gameState.questionNumber == 7) {
      this.changeShapes("question_7_1", "question_7_2", "question_7_3", "question_7_4", "fraction_7");
    } else if (gameState.questionNumber == 8) {
      this.changeShapes("question_8_1", "question_8_2", "question_8_3", "question_8_4", "fraction_8");
    } else if (gameState.questionNumber == 9) {
      this.changeShapes("question_9_1", "question_9_2", "question_9_3", "question_9_4", "fraction_9");
    } else if (gameState.questionNumber == 10) {
      this.changeShapes("question_10_1", "question_10_2", "question_10_3", "question_10_4", "fraction_10");
    }
  }

  correctAttempt(animObject, animKey, correctShape, celebrateLocX, celebrateLocY, correctAudio, confettiAudio, greenLitAudio, yayAudio) {
    attempts += 1;
    correctAnswer = true;
    gameState.score += 1;
    gameState.attempted += 1;

    if (hintOn == true) {
      this.hintButton.play("pop_out");
    }

    this.shape1.removeInteractive();
    this.shape2.removeInteractive();
    this.shape3.removeInteractive();
    this.shape4.removeInteractive();

    animObject.visible = true;
    animObject.play(animKey).setDepth(3); //which animation to play
    this.time.delayedCall(
      1000,
      function () {
        correctShape.setTint(0x3dd71); //which shape to change color
        correctAudio.play();
      },
      [],
      this
    );
    this.correctAnswer.x = celebrateLocX;
    this.correctAnswer.y = celebrateLocY;
    this.correctAnswer.anims.playAfterDelay("celebrate", 2000).setDepth(3); //where the celebrate animation should play
    this.time.delayedCall(1500, function () {
      confettiAudio.play();
    });

    this.shopTop.setDepth(3); //general for all

    this.time.delayedCall(
      1500,
      function () {
        animObject.setMask(this.mask); //which animation should be set mask

        goDown = false; //general
        goDownHangerLines = false;

        if (gameState.questionNumber == 1) {
          goUpShape1 = true;
          goUpShape2 = true;
          goUpShape4 = true;
        } else if (gameState.questionNumber == 2) {
          goUpShape1 = true;
          goUpShape3 = true;
          goUpShape4 = true;
        } else if (gameState.questionNumber == 3) {
          goUpShape2 = true;
          goUpShape3 = true;
          goUpShape4 = true;
        } else if (gameState.questionNumber == 4) {
          goUpShape1 = true;
          goUpShape2 = true;
          goUpShape4 = true;
        } else if (gameState.questionNumber == 5) {
          goUpShape1 = true;
          goUpShape2 = true;
          goUpShape3 = true;
        } else if (gameState.questionNumber == 6) {
          goUpShape2 = true;
          goUpShape3 = true;
          goUpShape4 = true;
        } else if (gameState.questionNumber == 7) {
          goUpShape1 = true;
          goUpShape3 = true;
          goUpShape4 = true;
        } else if (gameState.questionNumber == 8) {
          goUpShape1 = true;
          goUpShape3 = true;
          goUpShape4 = true;
        } else if (gameState.questionNumber == 9) {
          goUpShape1 = true;
          goUpShape2 = true;
          goUpShape4 = true;
        } else if (gameState.questionNumber == 10) {
          goUpShape2 = true;
          goUpShape3 = true;
          goUpShape4 = true;
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      3000,
      function () {
        this.add.sprite(384 + 102 * mul, 106, "correctBulb").setDepth(4);
        greenLitAudio.play();
      },
      [],
      this
    );

    this.time.delayedCall(
      5000,
      function () {
        //dart target is also general
        dartTarget.x = config.width / 2;
        dartTarget.y = 150;
        this.physics.moveToObject(animObject, dartTarget, 300); //which dart target to move
        if (gameState.questionNumber == 1) {
          goUpShape3 = true;
        } else if (gameState.questionNumber == 2) {
          goUpShape2 = true;
        } else if (gameState.questionNumber == 3) {
          goUpShape1 = true;
        } else if (gameState.questionNumber == 4) {
          goUpShape3 = true;
        } else if (gameState.questionNumber == 5) {
          goUpShape4 = true;
        } else if (gameState.questionNumber == 6) {
          goUpShape1 = true;
        } else if (gameState.questionNumber == 7) {
          goUpShape2 = true;
        } else if (gameState.questionNumber == 8) {
          goUpShape2 = true;
        } else if (gameState.questionNumber == 9) {
          goUpShape3 = true;
        } else if (gameState.questionNumber == 10) {
          goUpShape1 = true;
        }
        gameState.questionNumber += 1; //general
        //console.log(gameState.questionNumber);
      },
      [],
      this
    );

    this.time.delayedCall(
      6500,
      function () {
        correctAnswer = false; //general
        attempts = 0;
        goUpShape1 = false;
        goUpShape2 = false;
        goUpShape3 = false;
        goUpShape4 = false;
        hintOn = false;
        mul++;
        if (gameState.score == 5) {
          gameState.gameWin = true;
          this.scene.stop("TutorialScene");
          volumeState = 1;
          //config.audio.bgaudio.volume = 0;
          for (let vol = 1; vol <= 10; vol++) {
            this.time.delayedCall(400, function () {
              config.audio.bgaudio.volume = volumes[vol - 1];
            });
          }
          config.audio.bgaudio.stop();
          yayAudio.play();

          this.cameras.main.fadeOut(500, 255, 255, 255);
          for (let i = 1; i < 5; i++) {
            this["hangerLine" + i].setVisible(false);
            this["shape" + i].setVisible(false);
          }

          this.fraction.setVisible(false);

          this.cameras.main.once(
            "camerafadeoutcomplete",
            function (camera) {
              this.scene.stop("GameScene");
              this.scene.start("EndScene");
            },
            this
          );
        } else if (gameState.attempted == 10) {
          gameState.gameWin = false;
          this.scene.stop("TutorialScene");
          this.scene.start("EndScene");
        }
        correctShape.setTint(); //which correct shape should change tint
        this.changeQuestion(); //general
      },
      [],
      this
    );

    this.time.delayedCall(
      6700,
      function () {
        goDownHangerLines = true;
      },
      [],
      this
    );
  }

  update() {
    this.cartWheel.rotation += 0.001;

    if (this.cloudRight.x > -200) {
      this.cloudRight.x -= 0.2;
    } else {
      this.cloudRight.x = 1180;
    }

    this.parachute.y -= 0.1;
    if (this.parachute.y < -60) {
      this.parachute.y = 700;
    }

    if (goDown) {
      if (this.shape1.y < 360) this.shape1.y += 5;
      if (this.shape2.y < 360) this.shape2.y += 5;
      if (this.shape3.y < 360) this.shape3.y += 5;
      if (this.shape4.y < 360) this.shape4.y += 5;
    }

    if (goDownHangerLines) {
      if (this.hangerLine1.y < 255) this.hangerLine1.y += 5;
      if (this.hangerLine2.y < 255) this.hangerLine2.y += 5;
      if (this.hangerLine3.y < 255) this.hangerLine3.y += 5;
      if (this.hangerLine4.y < 255) this.hangerLine4.y += 5;
    }

    if (goUpShape1) {
      if (this.shape1.y > 150) {
        this.shape1.y -= 5;
      }
      if (this.hangerLine1.y > 150) {
        this.hangerLine1.y -= 5;
      }
    }

    if (goUpShape2) {
      if (this.shape2.y > 150) {
        this.shape2.y -= 5;
      }
      if (this.hangerLine2.y > 150) {
        this.hangerLine2.y -= 5;
      }
    }
    if (goUpShape3) {
      if (this.shape3.y > 150) {
        this.shape3.y -= 5;
      }
      if (this.hangerLine3.y > 150) {
        this.hangerLine3.y -= 5;
      }
    }
    if (goUpShape4) {
      if (this.shape4.y > 150) {
        this.shape4.y -= 5;
      }
      if (this.hangerLine4.y > 150) {
        this.hangerLine4.y -= 5;
      }
    }

    if (goUpAllShapes) {
      if (this.shape1.y > 150) this.shape1.y -= 5;
      if (this.shape2.y > 150) this.shape2.y -= 5;
      if (this.shape3.y > 150) this.shape3.y -= 5;
      if (this.shape4.y > 150) this.shape4.y -= 5;
      if (this.hangerLine1.y > 150) this.hangerLine1.y -= 5;
      if (this.hangerLine2.y > 150) this.hangerLine2.y -= 5;
      if (this.hangerLine3.y > 150) this.hangerLine3.y -= 5;
      if (this.hangerLine4.y > 150) this.hangerLine4.y -= 5;
    }

    if (this.dartHitAnim_1.body.speed > 0 &&
        Phaser.Math.Distance.Between(this.dartHitAnim_1.x, this.dartHitAnim_1.y, dartTarget.x, dartTarget.y) < 4) {
      this.dartHitAnim_1.stop("hit_1");
      this.dartHitAnim_1.visible = false;
      this.dartHitAnim_1.body.reset(config.width / 2, config.height / 2);
      this.dartHitAnim_1.clearMask();
    }

    if (this.dartHitAnim_2.body.speed > 0 &&
        Phaser.Math.Distance.Between(this.dartHitAnim_2.x, this.dartHitAnim_2.y, dartTarget.x, dartTarget.y) < 4) {
      this.dartHitAnim_2.stop("hit_2");
      this.dartHitAnim_2.visible = false;
      this.dartHitAnim_2.body.reset(config.width / 2, config.height / 2);
      this.dartHitAnim_2.clearMask();
    }

    if (this.dartHitAnim_3.body.speed > 0 &&
        Phaser.Math.Distance.Between(this.dartHitAnim_3.x, this.dartHitAnim_3.y, dartTarget.x, dartTarget.y) < 4) {
      this.dartHitAnim_3.stop("hit_3");
      this.dartHitAnim_3.visible = false;
      this.dartHitAnim_3.body.reset(config.width / 2, config.height / 2);
      this.dartHitAnim_3.clearMask();
    }

    if (this.dartHitAnim_4.body.speed > 0 &&
        Phaser.Math.Distance.Between(this.dartHitAnim_4.x, this.dartHitAnim_4.y, dartTarget.x, dartTarget.y) < 4) {
      this.dartHitAnim_4.stop("hit_4");
      this.dartHitAnim_4.visible = false;
      this.dartHitAnim_4.body.reset(config.width / 2, config.height / 2);
      this.dartHitAnim_4.clearMask();
    }
  } //update end
} //class end
